module.exports = __webpack_public_path__ + "img/no_results.017f77e8.svg";